'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = require('lodash');

var request = require('./request');
var storage = require('./storage');

var key = 'auth';

var Client = function () {
  function Client(config, auth) {
    _classCallCheck(this, Client);

    this.configure(config, auth);
  }

  _createClass(Client, [{
    key: 'configure',
    value: function configure(config) {
      var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : storage();

      this.config = config;
      this.store = store;
    }
  }, {
    key: 'setPassword',
    value: function setPassword(data) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        request('post', '/auth/set', data, _this.config).then(function (auth) {
          _this.store.setItem(key, JSON.stringify(auth));
          resolve(auth);
        }).catch(reject);
      });
    }
  }, {
    key: 'perform',
    value: function perform(method, endpoint, opts) {
      return request(method, endpoint, opts, this.config, this.credentials);
    }
  }, {
    key: 'uploadFile',
    value: function uploadFile(endpoint, opts) {
      return this.perform('post', endpoint, opts);
    }
  }, {
    key: 'credentials',
    get: function get() {
      return JSON.parse(this.store.getItem(key) || '{}');
    }
  }]);

  return Client;
}();

_.forEach(['get', 'post', 'put', 'patch', 'delete'], function (method) {
  return _.set(Client.prototype, method, function setter() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return this.perform.apply(this, [method].concat(args));
  });
});

module.exports = Client;